"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetOverwolfGamesResponseAllOfToJSON = exports.GetOverwolfGamesResponseAllOfFromJSONTyped = exports.GetOverwolfGamesResponseAllOfFromJSON = void 0;
var _1 = require("./");
function GetOverwolfGamesResponseAllOfFromJSON(json) {
    return GetOverwolfGamesResponseAllOfFromJSONTyped(json, false);
}
exports.GetOverwolfGamesResponseAllOfFromJSON = GetOverwolfGamesResponseAllOfFromJSON;
function GetOverwolfGamesResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'games': (json['games'].map(_1.OWGameFromJSON)),
    };
}
exports.GetOverwolfGamesResponseAllOfFromJSONTyped = GetOverwolfGamesResponseAllOfFromJSONTyped;
function GetOverwolfGamesResponseAllOfToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'games': (value.games.map(_1.OWGameToJSON)),
    };
}
exports.GetOverwolfGamesResponseAllOfToJSON = GetOverwolfGamesResponseAllOfToJSON;
